import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { PhotosPage } from '@/features/site/photos-page';

const searchSchema = z.object({
  capture: z.boolean().optional().catch(undefined),
});

export const Route = createFileRoute('/_app/projects/$projectId/site/photos')({
  validateSearch: searchSchema,
  component: PhotosRoute,
});

function PhotosRoute() {
  const { projectId } = Route.useParams();
  const { capture } = Route.useSearch();
  return <PhotosPage projectId={projectId} capture={capture} />;
}
